import { render, staticRenderFns } from "./BaseValidRadio.vue?vue&type=template&id=35eed607&"
import script from "./BaseValidRadio.vue?vue&type=script&lang=js&"
export * from "./BaseValidRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports